<!--
 * @Descripttion: 
 * @version: 
 * @Author: lfs
 * @Date: 2021年06月25日 13:47:08
-->
<template>
  <div class="route" @click="go(item)">
    <el-button :type="colorType" :icon="item.icon" circle :class="className"></el-button>
    <p class="atb-text-color-regular">{{ item.functionName }}</p>
    <div class="operation" v-if="operation" @click.stop="edit(item)">
      <i :class="[operation == 'plus' ? 'el-icon-circle-plus' : 'el-icon-remove']"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {};
  },
  props: {
    name: {
      default: '',
      type: String,
    },
    icon: {
      default: '',
      type: String,
    },
    item: {
      default: new Object(),
      type: Object,
    },
    colorType: {
      default: '0',
      type: String,
    },
    operation: {
      default: '',
      type: String,
    },
    className: {
      default: '',
      type: String,
    },
  },
  created() {},
  mounted() {},
  methods: {
    go(e) {
      this.$emit('go', e);
    },
    edit(e) {
      if (this.operation === 'plus') {
        this.$emit('plus', e);
      } else if (this.operation === 'remove') {
        this.$emit('remove', e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.route {
  cursor: pointer;
  margin-right: 48px;
  position: relative;
  .el-button {
    color: $--color-white;
  }
  .el-button--1 {
    background-color: $--color-primary;
    border-color: $--color-primary;
    box-shadow: 0 0 8px rgba($color: $--color-primary, $alpha: 0.4);
  }
  .el-button--2 {
    background-color: $--color-route-blue;
    border-color: $--color-route-blue;
    box-shadow: 0 0 8px rgba($color: $--color-route-blue, $alpha: 0.4);
  }
  .el-button--3 {
    background-color: $--color-route-green;
    border-color: $--color-route-green;
    box-shadow: 0 0 8px rgba($color: $--color-route-green, $alpha: 0.4);
  }
  .el-button--4 {
    background-color: $--color-route-yellow;
    border-color: $--color-route-yellow;
    box-shadow: 0 0 8px rgba($color: $--color-route-yellow, $alpha: 0.4);
  }
  .el-button--0 {
    background-color: $--color-route-purple;
    border-color: $--color-route-purple;
    box-shadow: 0 0 8px rgba($color: $--color-route-purple, $alpha: 0.4);
  }
  .el-button--add {
    background-color: $--color-white;
    border-color: $--color-white;
    color: $--color-icon;
  }
  .operation {
    position: absolute;
    top: 0;
    right: -18px;
    i {
      font-size: 20px;
      color: rgba($color: #000000, $alpha: 0.4);
      &:hover{
        color: rgba($color: #000000, $alpha: 0.6);
      }
    }
  }
}
</style>
